export default __webpack_public_path__ + "static/media/m-logo.5c4ea40c.png";